import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import toastr from 'COMPONENTS/ShowTostr/ShowTostr';
import _ from "lodash";

import HeaderContainer from "../Header/HeaderContainer";
import Spinner from "COMPONENTS/Spinner/Spinner";
import SettingsPage from "./SettingsPage";
// Constants
import { ERROR } from "UTILS/Constants";
// selectors
import { selectUserName, selectCustomerId } from "../../MainLayout/selectors";
import { selectUserRole } from "../../Whiteboard/selectors";
import { 
  getModules, getHeaderIcons, selectAllowedDownloads, selectSubModulesScreenshare,
  selectSubModulesAudioVideo, selectSubModulesCoBrowse, selectSubModulesSnapShot,
  getIsOrganizer, getSubLoggingLevels, getLoggingLevel, getSSODetails, 
  getStorageDetails, getRecordingStorageDetails,
  isDownloadModuleSelected, getIsSSOEnabled, getIsSystemPassword, 
  getURIIdentifier, getIsPasscodeEnabled, getBandwidthSettings, 
  isVideoOrSnapshotSelected, isScreenShareSelected, isVideoSelected,
  isCoBrowseSelected, isSnapShotSelected,
  getConcurrentSessionData, getScreenMaskSetting,
} from "../../CommonComponents/Header/selectors";
import {
  getUserNotifySetting, getUserInventMsgCustomize, getIsEntryAllowed, getIconLarge,
  getIsReductionLogs, getHorizontalDisplayFixed, getDisableCanvasEdit, getDisableIcsFile,
  getOperatorExclusiveRecordingControl, getRingtoneLoopEnabled,
  getDisableInitiatingCoBrowse, getDisableCanvasDownload,
  getEnableVideoBlur, getIsPreviewResize,
  getCustomBandwidthAUDIO_VIDEO, getCustomBandwidthSCREENSHARE, getConsentMessage, getIsCoBrowseContentShown, 
  getIsMaskingEnabled, getInbCSSelectors, getUniversalLinks, getUniversalLinksEnabled, getSetTexts, getSetTextEnabled
} from "REDUX/Selector/OrganisationSelector";

//Utilities

// Strings
import { getMessage } from "CONFIG/i18n";

//Actions
import { organisationAction } from "CONFIG/ActionFactory";

class SettingsPageContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      spinnerVisibility: false,
    };
  }

  componentDidMount () {
    this.getCustomerInfo();
  }
  getCustomerInfo = () => {
    this.setState({spinnerVisibility: true});
    organisationAction.getCustomersAction(this.props.customerId).then(
      responseObject => {  
        this.setState({spinnerVisibility:false});
      }, error => {
        console.error("Error getting customer info", error);
        this.setState({spinnerVisibility: false});
      });
  };

  renderSpinner = () => {
    return <Spinner showSpinner={this.state.spinnerVisibility} />;
  }

  getS3SaveStatusErrorMessage = (error) => {
    const s3SaveStatus = error && error.details ? error.details.s3SaveStatus : null;
    if (!s3SaveStatus) return null;

    const savedTargets = [];
    if (s3SaveStatus.inbCSSelectors) savedTargets.push(getMessage("CSS_SELECTOR"));
    if (s3SaveStatus.universalLinks) savedTargets.push(getMessage("UNIVERSAL_LINKS"));
    if (s3SaveStatus.setTexts) savedTargets.push(getMessage("UI_SETTINGS_GUEST"));

    // どれも保存に成功していないならメッセージを返さない
    if (!savedTargets.length) return null;
    // 保存に成功した項目を結合してメッセージを返す
    return getMessage("SETTINGS_S3_SAVE_FAILED", { targets: savedTargets.join(", ") });
  }

  handleCancelClick = () => {
    this.props.history.goBack();
  };

  verifyStorage=(storageElement,callback)=>{
    this.setState({spinnerVisibility: true })
    organisationAction.verifyStorage(storageElement).then(
      data => {
        this.setState({spinnerVisibility: false })
        callback && callback();
      }
    ).catch (
      error => {
        this.setState({spinnerVisibility: false })
        callback && callback(error);
      }
    )
  }

  updateCustomerSettings = (details, callback)=>{
    this.setState({spinnerVisibility: true });
    organisationAction.updateCustomerSettings(this.props.customerId, details).then(
      data => { organisationAction.getCustomersAction(this.props.customerId).then(
        responseObject => {
          callback && callback();
          toastr.success(getMessage("SETTINGS_SAVED"));
          this.setState({spinnerVisibility:false},()=>{ 
            setTimeout(()=>{this.props.history.goBack()
            },1000)}); 
        });
      }
    ).catch (
      error => {
        this.setState({spinnerVisibility:false})
        if(error.code !== ERROR.NOT_AUTHORIZED) {
          const s3SaveStatusMessage = this.getS3SaveStatusErrorMessage(error);
          const baseErrorMessage = getMessage(error.code);
          const mergedMessage = s3SaveStatusMessage
            ? `${baseErrorMessage}<br/>${s3SaveStatusMessage}`
            : baseErrorMessage;
          toastr.error(mergedMessage);
        }
        callback && callback(error);
      }
    )
  }

  render() {
    return (
      <>
        {this.renderSpinner()}
        <HeaderContainer
          title={getMessage("SETTINGS")}
          headerButtonText={getMessage("ADD_USER")}
          showModal={false}
          history={this.props.history}
          showAboutOrgModal={false}
          getAllUserData={()=>{}}
          logoUrl={this.props.logoUrl}
          showQRPopUp={false}
          isAdmin={true}
          showQR={false}
          isDashboard={false}
        />
        <SettingsPage
          verifyStorage={this.verifyStorage}
          updateCustomerSettings={this.updateCustomerSettings}
          handleCancelClick={this.handleCancelClick} 
          userName={this.props.userName}
          role={this.props.role}
          customerId={this.props.customerId}
          modules={this.props.modules}
          allowedDownloads={this.props.allowedDownloads}
          subModulesScreenshare={this.props.subModulesScreenshare}
          subModulesAudioVideo={this.props.subModulesAudioVideo}
          subModulesCoBrowse={this.props.subModulesCoBrowse}
          subModulesSnapShot={this.props.subModulesSnapShot}
          isOrganizer={this.props.isOrganizer}
          availableSubLoggingLevels={this.props.availableSubLoggingLevels}
          loggingLevel={this.props.loggingLevel}
          storageDetails={this.props.storageDetails}
          recordingStorageDetails={this.props.recordingStorageDetails}
          SSODetails={this.props.SSODetails}
          bandwidthSettings={this.props.bandwidthSettings}
          isDownloadModuleSelected={this.props.isDownloadModuleSelected}
          isVideoSelected={this.props.isVideoSelected}
          isVideoOrSnapshotSelected={this.props.isVideoOrSnapshotSelected}
          isScreenShareSelected={this.props.isScreenShareSelected}
          isCoBrowseSelected={this.props.isCoBrowseSelected}
          isSnapShotSelected={this.props.isSnapShotSelected}
          headerIcons={this.props.headerIcons}
          isSSOEnabled={this.props.isSSOEnabled}
          uriIdentifier={this.props.uriIdentifier}
          isPasscodeEnabled={this.props.isPasscodeEnabled}
          isSystemPassword={this.props.isSystemPassword}
          logoUrl={this.props.logoUrl}
          concurrentSessionData={this.props.concurrentSessionData}
          cobrowseSettings={this.props.cobrowseSettings}
          availableModules={this.props.availableModules}
          recordingMethod={this.props.recordingMethod}
          recordingTarget={this.props.recordingTarget}
          modalRecordingMessage={this.props.modalRecordingMessage}
          audioRecordingMessage={this.props.audioRecordingMessage}
          videoRecordingMessage={this.props.videoRecordingMessage}
          retentionPeriod={this.props.retentionPeriod}
          userNotifySetting={this.props.userNotifySetting}
          userInventMsgCustomize={this.props.userInventMsgCustomize}
          screenMaskSetting={this.props.screenMaskSetting}
          isEntryAllowedSettings={this.props.isEntryAllowedSettings}
          isReductionLogs={this.props.isReductionLogs}
          horizontalDisplayFixedSettings={this.props.horizontalDisplayFixedSettings}
          disableCanvasEdit={this.props.disableCanvasEdit}
          disableIcsFile={this.props.disableIcsFile}
          operatorSkills={this.props.operatorSkills}
          operatorExclusiveRecordingControl={this.props.operatorExclusiveRecordingControl}
          ringtoneLoopEnabled={this.props.ringtoneLoopEnabled}
          disableInitiatingCoBrowse={this.props.disableInitiatingCoBrowse}
          disableCanvasDownload={this.props.disableCanvasDownload}
          enableVideoBlur={this.props.enableVideoBlur}
          isPreviewResize={this.props.isPreviewResize}
          customBandwidthAUDIO_VIDEO={this.props.customBandwidthAUDIO_VIDEO}
          customBandwidthSCREENSHARE={this.props.customBandwidthSCREENSHARE}
          inbConsentMessage={this.props.inbConsentMessage}
          inbShowCoBrowseContent={this.props.inbShowCoBrowseContent}
          inbIsMaskingEnabled={this.props.inbIsMaskingEnabled}
          inbGetSelectors={this.props.inbGetSelectors}
          universalLinks={this.props.universalLinks}
          universalLinksEnabled={this.props.universalLinksEnabled}
          setTexts={this.props.setTexts}
          setTextEnabled={this.props.setTextEnabled}
        />
       </>
    )
  }
}

const mapStateToProps = state => {
  return {
    userName: selectUserName(state),
    role: selectUserRole(state),
    customerId: selectCustomerId(state),
    modules: getModules(state),
    allowedDownloads: selectAllowedDownloads(state),
    subModulesScreenshare: selectSubModulesScreenshare(state),
    subModulesAudioVideo: selectSubModulesAudioVideo(state),
    subModulesCoBrowse: selectSubModulesCoBrowse(state),
    subModulesSnapShot: selectSubModulesSnapShot(state),
    isOrganizer: getIsOrganizer(state),
    availableSubLoggingLevels: getSubLoggingLevels(state),
    loggingLevel: getLoggingLevel(state),
    storageDetails: getStorageDetails(state),
    recordingStorageDetails: getRecordingStorageDetails(state),
    SSODetails:getSSODetails(state),
    isDownloadModuleSelected: isDownloadModuleSelected(state),
    isScreenShareSelected: isScreenShareSelected(state),
    isCoBrowseSelected: isCoBrowseSelected(state),
    isSnapShotSelected: isSnapShotSelected(state),
    isVideoSelected: isVideoSelected(state),
    isVideoOrSnapshotSelected: isVideoOrSnapshotSelected(state),
    headerIcons: getHeaderIcons(state),
    isSSOEnabled: getIsSSOEnabled(state),
    uriIdentifier: getURIIdentifier(state),
    isPasscodeEnabled: getIsPasscodeEnabled(state),
    isSystemPassword: getIsSystemPassword(state),
    bandwidthSettings: getBandwidthSettings(state),
    logoUrl: state.OrganisationReducer.logoUrl,
    concurrentSessionData: getConcurrentSessionData(state),
    cobrowseSettings: state.OrganisationReducer.cobrowseSettings,
    availableModules: state.OrganisationReducer.customerData.modules,
    recordingMethod: state.OrganisationReducer.customerData.recordingMethod,
    recordingTarget: state.OrganisationReducer.customerData.recordingTarget,
    modalRecordingMessage: state.OrganisationReducer.customerData.modalRecordingMessage,
    audioRecordingMessage: state.OrganisationReducer.customerData.audioRecordingMessage,
    videoRecordingMessage: state.OrganisationReducer.customerData.videoRecordingMessage,
    retentionPeriod: state.OrganisationReducer.customerData.retentionPeriod,
    userNotifySetting: getUserNotifySetting(state),
    userInventMsgCustomize: getUserInventMsgCustomize(state),
    screenMaskSetting: getScreenMaskSetting(state),
    isEntryAllowedSettings: getIsEntryAllowed(state),
    isReductionLogs: getIsReductionLogs(state),
    horizontalDisplayFixedSettings: getHorizontalDisplayFixed(state),
    disableCanvasEdit: getDisableCanvasEdit(state),
    disableIcsFile: getDisableIcsFile(state),
    operatorSkills: state.OrganisationReducer.operatorSkills,
    operatorExclusiveRecordingControl: getOperatorExclusiveRecordingControl(state),
    ringtoneLoopEnabled: getRingtoneLoopEnabled(state),
    disableInitiatingCoBrowse: getDisableInitiatingCoBrowse(state),
    disableCanvasDownload: getDisableCanvasDownload(state),
    enableVideoBlur: getEnableVideoBlur(state),
    isPreviewResize: getIsPreviewResize(state),
    customBandwidthAUDIO_VIDEO: getCustomBandwidthAUDIO_VIDEO(state),
    customBandwidthSCREENSHARE: getCustomBandwidthSCREENSHARE(state),
    inbConsentMessage: getConsentMessage(state),
    inbShowCoBrowseContent: getIsCoBrowseContentShown(state),
    inbIsMaskingEnabled: getIsMaskingEnabled(state),
    inbGetSelectors: getInbCSSelectors(state),
    universalLinks: getUniversalLinks(state),
    universalLinksEnabled: getUniversalLinksEnabled(state),
    setTexts: getSetTexts(state),
    setTextEnabled: getSetTextEnabled(state),
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(SettingsPageContainer));
